var _rect, _rect2, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCharts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 480 480"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 16,
    height: 480
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 464,
    width: 480,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M229.1,433.2v-136c0-4.4-3.6-8-8-8h-80c-4.4,0-8,3.6-8,8v136H229.1z M149.1,305.2h64v128h-64V305.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.4,432V200c0-4.4-3.6-8-8-8h-80c-4.4,0-8,3.6-8,8v232H148.4z M68.4,208h64v224h-64V208z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M442.9,432V104c0-4.4-3.6-8-8-8h-80c-4.4,0-8,3.6-8,8v328H442.9z M362.9,112h64v320h-64V112z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M362,432V8c0-4.4-3.6-8-8-8h-80c-4.4,0-8,3.6-8,8v424H362z M282,16h64v416h-64V16z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharts);
export default __webpack_public_path__ + "static/media/Charts.42df4c34.svg";
export { ForwardRef as ReactComponent };